import { HelixIcon } from '@helix/helix-icon'
import { checkmark as CheckIcon } from '@helix/helix-icon/outlined'
import { getLocationIcon } from './utils'
import { OrgOption } from './types'

interface OrganizationListProps {
  options: OrgOption[]
  selectedOptions: OrgOption[]
  onChange: (option: OrgOption | OrgOption[]) => void
}

export function OrganizationList({
  options,
  selectedOptions,
  onChange
}: OrganizationListProps) {
  // Filter out disabled options - only show selectable items
  const selectableOptions =
    options?.filter((option) => !option.isDisabled) || []

  return (
    <div className="flex max-h-[196px] flex-col overflow-y-auto">
      {selectableOptions.map((option) => {
        const isSelected = selectedOptions.some(
          (selectedOption) => selectedOption.value.id === option.value.id
        )
        return (
          <div
            key={option.value.id}
            className="flex cursor-pointer items-center gap-2 px-3 py-2 hover:bg-gray-100"
            role="button"
            tabIndex={0}
            onClick={() => onChange(option)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                onChange(option)
              }
            }}>
            {getLocationIcon(option.value.type)}
            <span className="helix-body">
              Anyone {option.value.type === 'Team' ? 'on' : 'at'}{' '}
              <span className="helix-body--strong">{option.label}</span>
            </span>
            {isSelected && (
              <HelixIcon
                icon={CheckIcon}
                className="helix-svg-fill--green-700 ml-auto"
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
